import { render, staticRenderFns } from "./IntershipNewsManagement.vue?vue&type=template&id=73cc4f8c"
import script from "./IntershipNewsManagement.vue?vue&type=script&lang=js"
export * from "./IntershipNewsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports